export const isMac = /Macintosh/.test(navigator.userAgent);
export const ctrlKeySymbol = isMac ? "⌘" : "CTRL";
